import { Avatar, AvatarFallback, AvatarImage } from "ui/components/avatar";
import { fullName, initials } from "components/employee/utils";

import React from "react";
import { assetUrl } from "utils";

const AvatarDisplay = ({ user, ...props }) => {
  return (
    <Avatar {...props}>
      <AvatarImage src={assetUrl(user?.avatar)} alt={fullName(user)} />
      <AvatarFallback>{initials(user)}</AvatarFallback>
    </Avatar>
  );
};

export default AvatarDisplay;
